// src/main.js
import Vue from 'vue'
import App from './App'
// 导入路由
import router from './router'
// 导入Vuex
import store from './store'
// 导入Element UI和样式
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 注册Element UI插件
Vue.use(ElementUI)

// 关闭生产环境提示
Vue.config.productionTip = false

new Vue({
  el: '#app',
  router, // 注入路由
  store,  // 注入Vuex
  render: h => h(App) // 渲染根组件
})